/**
 * CCA Printing — EmailJS + Cloudinary Form Handler
 * Handles quote forms on homepage and banner landing pages.
 * Files are uploaded to Cloudinary first, then URLs sent via EmailJS.
 * Loaded as a Shopify asset to avoid </script> escaping in custom liquid.
 */
(function () {
  var PUBLIC_KEY = 'Rta3_8bsCHSC0J-RC';
  var SERVICE_ID = 'service_1k6cf2t';
  var TEMPLATE_HOME = 'template_w42cmrm';
  var TEMPLATE_LP = 'template_ablzz8s';

  var CLOUDINARY_CLOUD = 'dmlaqll4a';
  var CLOUDINARY_PRESET = 'cca_quote_uploads';
  var CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/auto/upload';

  function initForms() {
    emailjs.init(PUBLIC_KEY);
    setupForm('quick-quote-form', '.qc-submit', TEMPLATE_HOME);
    setupForm('lp-quote-form', '.lp-submit', TEMPLATE_LP);
    setupForm('lp-quote-form-2', '.lp-submit-2', TEMPLATE_LP);

    // On banner LP: hero CTA scrolls to bottom quote form
    var heroSection = document.querySelector('[id*="hero_HH7JLL"]');
    if (heroSection) {
      var heroLink = heroSection.querySelector('a[href*="contact"]');
      if (heroLink) {
        heroLink.addEventListener('click', function (e) {
          var target = document.getElementById('lp-quote-form-2');
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    }
  }

  /**
   * Upload a single file to Cloudinary.
   * Returns a promise that resolves with the secure URL.
   */
  function uploadToCloudinary(file) {
    var formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_PRESET);

    return fetch(CLOUDINARY_URL, {
      method: 'POST',
      body: formData
    }).then(function (res) {
      if (!res.ok) throw new Error('Upload failed: ' + res.statusText);
      return res.json();
    }).then(function (data) {
      return data.secure_url;
    });
  }

  /**
   * Upload all files from a file input to Cloudinary.
   * Returns a promise that resolves with an array of URLs.
   */
  function uploadAllFiles(fileInput) {
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      return Promise.resolve([]);
    }
    var uploads = [];
    for (var i = 0; i < fileInput.files.length; i++) {
      uploads.push(uploadToCloudinary(fileInput.files[i]));
    }
    return Promise.all(uploads);
  }

  function setupForm(formId, btnSelector, templateId) {
    var form = document.getElementById(formId);
    if (!form) return;
    var btn = form.querySelector(btnSelector);
    if (!btn) return;
    var originalText = btn.textContent;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      btn.textContent = 'Uploading files...';
      btn.disabled = true;

      var fileInput = form.querySelector('input[type="file"]');

      uploadAllFiles(fileInput).then(function (urls) {
        btn.textContent = 'Sending...';

        // Build template params from form fields (excluding file input)
        var params = {};
        var elements = form.elements;
        for (var i = 0; i < elements.length; i++) {
          var el = elements[i];
          if (el.name && el.type !== 'file' && el.type !== 'submit') {
            params[el.name] = el.value;
          }
        }

        // Append file URLs to the message so they appear in the email
        if (urls.length > 0) {
          var linkList = urls.map(function (url, i) {
            return 'File ' + (i + 1) + ': ' + url;
          }).join('\n');
          params.message = (params.message || '') + '\n\n--- Attached Files ---\n' + linkList;
        }

        return emailjs.send(SERVICE_ID, templateId, params);
      }).then(
        function () {
          btn.textContent = 'Sent ✓';
          btn.style.background = '#16a34a';
          form.reset();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 3000);
          window.location.href = "https://www.ccaprinting.com/pages/home-thank-you";
        },
        function (error) {
          btn.textContent = 'Error — try again';
          btn.style.background = '#dc2626';
          btn.disabled = false;
          console.error('Form error:', error);
          setTimeout(function () {
            btn.textContent = originalText;
            btn.style.background = '';
          }, 3000);
        }
      );
    });
  }

  // Dynamically load the EmailJS CDN then init
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
  script.onload = initForms;
  document.head.appendChild(script);
})();
